import React  from "react";

import {

  Table,


  

  
} from "reactstrap";



// Redux


const CasosDetallesLista = ({gestionesCaso}) => {

        console.log(gestionesCaso)
    




    return ( 
        <React.Fragment>
        


            <div className="table-responsive">

                              <Table
                                      className="table table-bordered table-striped text-center mb-3"
                                      hover
                                    >
                                    <thead>

                                        {/* Fecha FInalizar */}
                                    <tr style={{ backgroundColor: '#33302e'  , color:"white"}} >
                                            {Array.isArray(gestionesCaso) ? gestionesCaso.map(item => (
                                                        item.fecha_finalizar !== '' ? (
                                                        <React.Fragment key={item.id}>
                                                            <th>Fecha finalizar</th>
                                                            <th>{item.fecha_finalizar}</th>
                                                            <th>Usuario</th>
                                                            <th>{item.usuario}</th>
                                                        </React.Fragment>
                                                        ) : null
                                                    )) : null}



                                        </tr>



                                                            {/* Fecha Reanudar */}
                                        <tr>
                                            {Array.isArray(gestionesCaso) ? gestionesCaso.map(item => (
                                                        item.fecha_reanudar !== '' ? (
                                                        <React.Fragment key={item.id}>
                                                            <th>Fecha reanudar</th>
                                                            <th>{item.fecha_reanudar}</th>
                                                            <th>Usuario</th>
                                                            <th>{item.usuario}</th>
                                                        </React.Fragment>
                                                        ) : null
                                                    )) : null}
                                            </tr>


                                                            {/* Fecha Pausa */}

                                              <tr >
                                            {Array.isArray(gestionesCaso) ? gestionesCaso.map(item => (
                                                        item.fecha_pausa !== '' ? (
                                                        <React.Fragment key={item.id}>
                                                            <th>Fecha pausa</th>
                                                            <th>{item.fecha_pausa}</th>
                                                            <th>Usuario</th>
                                                            <th>{item.usuario}</th>
                                                        </React.Fragment>
                                                        ) : null
                                                    )) : null}
                                            </tr>


                                                            {/* Fecha Iniciar */}
                                            <tr >
                                            {Array.isArray(gestionesCaso) ? gestionesCaso.map(item => (
                                                        item.fecha_iniciar !== '' ? (
                                                        <React.Fragment key={item.id}>
                                                            <th>Fecha iniciar</th>
                                                            <th>{item.fecha_iniciar}</th>
                                                            <th>Usuario</th>
                                                            <th>{item.usuario}</th>
                                                        </React.Fragment>
                                                        ) : null
                                                    )) : null}
                                        </tr>


                                                            {/* Fecha Aceptar */}
                                            <tr style={{ backgroundColor: '#33302e'  , color:"white"}}>
                                            {Array.isArray(gestionesCaso) ? gestionesCaso.map(item => (
                                                        item.fecha_aceptar !== '' ? (
                                                        <React.Fragment key={item.id}>
                                                            <th>Fecha aceptar</th>
                                                            <th>{item.fecha_aceptar}</th>
                                                            <th>Usuario</th>
                                                            <th>{item.usuario}</th>
                                                        </React.Fragment>
                                                        ) : null
                                                    )) : null}
                                            </tr>

                                                            {/* Fecha Asignar */}
                                                <tr>
                                                {Array.isArray(gestionesCaso) ? gestionesCaso.map(item => (
                                                        item.fecha_asignar !== '' ? (
                                                        <React.Fragment key={item.id}>
                                                            <th>Fecha asignar</th>
                                                            <th>{item.fecha_asignar}</th>
                                                            <th>Usuario</th>
                                                            <th>{item.usuario}</th>
                                                        </React.Fragment>
                                                        ) : null
                                                    )) : null}


                                                </tr>   


                                                    
                                        
                                        </thead>
                                        </Table>
                                        </div>

      </React.Fragment>
       
     );
}
 
export default CasosDetallesLista;